






























import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { OptionPayload } from '@/store/Mobile/state';

import formatter from '@/mixins/formatter';

import ProductCount from '@/components/Molecules/Input/ProductCount.vue';
import ListItem from '@/components/Atoms/ListItem/ListItemWithBorder.vue';
import Number from '@/components/Atoms/Input/Number.vue';
import OptionInputArea from '@/components/Pages/MobileEstimate/Partial/OptionInputArea.vue';

@Component({
  components: {
    OptionInputArea,
    ListItem,
    ProductCount,
    Number,
  },
})
export default class Option extends mixins(formatter) {
  @Prop() private item!: any;
  @Prop() private index!: number;
  @Prop() private simTypeId!: string;
  @Prop() private namespace!: string;
  @Prop() planCountList!: number[];
  @Prop() hasError!: boolean;
  countList = [0, 0];
  private carriers = ['docomo', 'au']; // TODO: 定義を持つ場所を決める

  payload(carrier: string): OptionPayload {
    return {
      stateKey: 'options',
      carrier: carrier,
      simType: this.simTypeId,
      groupId: this.item.groupId,
      id: this.item.id,
    };
  }

  planCount(carrier: string) {
    return carrier == 'docomo' ? this.planCountList[0] : this.planCountList[1];
  }

  get selected(): boolean {
    return this.total > 0;
  }

  get total() {
    return this.countList.reduce((z, n) => {
      return z + n;
    }, 0);
  }

  updateCount(args: { index: number; count: number }) {
    this.countList.splice(args.index, 1, args.count);
  }
}
